import {
    useMiniApp as useMiniAppTG,
    useLaunchParams as useLaunchParamsTG,
    useBackButton as useBackButtonTG,
    useViewport as useViewportTG,
    useHapticFeedback as useHapticFeedbackTG,
    useMainButton as useMainButtonTG,
    useThemeParams as useThemeParamsTG,
    useClosingBehavior as useClosingBehaviorTG,
    useUtils as useUtilsTG,
    useQRScanner as useQRScannerTG,
} from '@tma.js/sdk-react'
import { isTelegramWeb } from './utils'

export function useMiniApp(...args: Parameters<typeof useMiniAppTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useMiniAppTG(...args)
    } catch(e) {
        return null
    }
}

export function useLaunchParams(...args: Parameters<typeof useLaunchParamsTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useLaunchParamsTG(...args)
    } catch(e) {
        return null
    }
}

export function useBackButton(...args: Parameters<typeof useBackButtonTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useBackButtonTG(...args)
    } catch(e) {
        return null
    }
}

export function useViewport(...args: Parameters<typeof useViewportTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useViewportTG(...args)
    } catch(e) {
        return null
    }
}

export function useHapticFeedback(...args: Parameters<typeof useHapticFeedbackTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useHapticFeedbackTG(...args)
    } catch(e) {
        return null
    }
}

export function useMainButton(...args: Parameters<typeof useMainButtonTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useMainButtonTG(...args)
    } catch(e) {
        return null
    }
}

export function useThemeParams(...args: Parameters<typeof useThemeParamsTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useThemeParamsTG(...args)
    } catch(e) {
        return null
    }
}

export function useClosingBehavior(...args: Parameters<typeof useClosingBehaviorTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useClosingBehaviorTG(...args)
    } catch(e) {
        return null
    }
}

export function useUtils(...args: Parameters<typeof useUtilsTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useUtilsTG(...args)
    } catch(e) {
        return null
    }
}

export function useQRScanner(...args: Parameters<typeof useQRScannerTG>) {
    try {
        if (!isTelegramWeb()) throw new Error('Outside')
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useQRScannerTG(...args)
    } catch(e) {
        return null
    }
}